import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeadIconPound = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 50 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M.126 1.961L0 1.4C0 .627.67 0 1.493 0h38.38c1.212 0 2.319.642 2.86 1.658l6.93 13c.45.845.45 1.84 0 2.684l-6.93 13C42.193 31.358 41.086 32 39.874 32H1.493c-.206 0-.41-.04-.598-.117-.756-.31-1.1-1.136-.77-1.844L6.486 16.4a.943.943 0 0 0 0-.802L.126 1.961zM32.4 20.643h-1.514c-.332 0-.6.24-.6.536v2.537H22.6V17.07h5c.331 0 .6-.24.6-.535v-1.072c0-.296-.269-.535-.6-.535h-5v-3.442c0-1.67 1.34-3.008 3.648-3.008 1.297 0 2.434.53 3.027.868a.65.65 0 0 0 .788-.115l.983-1.085c.218-.24.163-.594-.118-.773A8.883 8.883 0 0 0 26.217 6C22.286 6 19.4 8.284 19.4 11.376v3.553H18c-.331 0-.6.24-.6.535v1.072c0 .296.269.535.6.535h1.4v6.645h-1.8c-.331 0-.6.24-.6.536v1.212c0 .296.269.536.6.536h14.8c.331 0 .6-.24.6-.536V21.18c0-.296-.269-.536-.6-.536z",
		fillRule: "nonzero",
		stroke: "none",
		strokeWidth: 1
	})
});
export default SvgLeadIconPound;
